import { useCallback } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';

type SuccessfulTransactionProps = {
    location: { search: string };
    transactionId: unknown;
    retailPrice: unknown;
    isShare: boolean;
};

function SuccessfulTransaction(_props: SuccessfulTransactionProps) {
    const redirectToReward = useCallback(() => {
        const w = window as any;
        if (w.ReactNativeWebView && typeof w.ReactNativeWebView.postMessage === 'function') {
            try {
                w.ReactNativeWebView.postMessage(
                    JSON.stringify({ type: 'CLOSE_WEBVIEW', source: 'transaction_success_ok' })
                );
            } catch (_error) {
                w.ReactNativeWebView.postMessage('CLOSE_WEBVIEW');
            }
            return;
        }
        if (window.history.length > 1) {
            window.history.back();
            return;
        }
        window.close();
    }, []);

    return (
        <div className="card Card-container card-pd-B">
            <div className="row Mb-3 Mb-B10" style={{ height: '100vh' }}>
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="box-center">
                        <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                                <div className="transaction-success">Transaction Successful</div>
                            </div>
                        </div>

                        <div className="row Mb-3 Mb-B10 ">
                            <div className="col-sm-12 col-md-12 col-lg-12">
                                <div className="" style={{ padding: '5px 0px' }}>
                                    <div className="card-body no-Pd" style={{ textAlign: 'center' }}>
                                        <svg className="" width="100" height="100" viewBox="0 0 100 100">
                                            <circle className="checkmark-disc" cx="50" cy="50" r="48" stroke="#4CAF50" strokeWidth="1" fill="#eef4f7">
                                                {' '}
                                            </circle>
                                            <path
                                                className="checkmark-check"
                                                d="M75 33L40 66 25 50"
                                                fill="none"
                                                stroke="#4CAF50"
                                                strokeWidth="3"
                                                strokeLinecap="round"
                                            ></path>
                                        </svg>

                                        <div className="card-body card-Pd alignCen">
                                            <h1 className="conformation-info-align">
                                                Confirmation sent to your <br /> Email / SMS
                                            </h1>
                                        </div>

                                        <div className="thank-you-align-text">Thank You !</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{ textAlign: 'center' }}>
                            <button type="button" className="btn btn-primary continue-button-style" onClick={redirectToReward}>
                                OK, Continue
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state: { pay: { transactionId: unknown; retailPrice: unknown }; verify: { isShare: boolean } }) => ({
    transactionId: state.pay.transactionId,
    retailPrice: state.pay.retailPrice,
    isShare: state.verify.isShare,
});

export default compose(connect(mapStateToProps), withRouter)(SuccessfulTransaction);
